import { Dispatch } from 'redux';

import { setCookie } from 'ha/modules/Cookies';
import CookiesConstants from 'ha/constants/Cookies';

import { nestpickDomain } from '../constants';

interface Query {
  utm_source?: string;
  nestpick_transaction_id?: string;
}

export default ({ utm_source, nestpick_transaction_id }: Query) => (
  dispatch: Dispatch,
) => {
  if (utm_source === nestpickDomain && nestpick_transaction_id) {
    dispatch(
      setCookie(CookiesConstants.NESTPICK_UTM, nestpick_transaction_id, {
        expires: 30,
      }),
    );
  }
};
